// Funzione che verifica se un utente è superAdmin
function isUserASuperAdmin (email) {
  const re = new RegExp('.*@plusadvance.com$')
  return re.test(email)
}
export default function isPaOperator (email) {
  const isPA = isUserASuperAdmin(email)
  return isPA && (email === 'simona.busatta@plusadvance.com' || email === 'elena.tonelli@plusadvance.com')
}
